import { Directive, Output, EventEmitter, HostListener } from '@angular/core';
/**
 * CAPS LOCK - warn user Caps lock is on
 */
@Directive({
  selector: '[appCaps]'
})
export class CapsLockDirective {
  /**
   * broadcast capslock event
   */
  @Output() capsLock = new EventEmitter<boolean>();

  /**
   * constructor to inject dependency
   */
  constructor() {}

  /**
   * keydown event
   * @param event keydown event
   */
  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const capsOn = event.getModifierState && event.getModifierState('CapsLock');
    this.capsLock.emit(capsOn);
  }

  /**
   * keypress event
   * @param event keypress event
   */
  @HostListener('window:keyup', ['$event'])
  onKeyUp(event: KeyboardEvent): void {
    const capsOn = event.getModifierState && event.getModifierState('CapsLock');
    this.capsLock.emit(capsOn);
  }
}
